import { useState } from 'react'
import { useTheme } from '../../contexts/ThemeContext'
import { fonts } from '../../lib/themes'

const C = 283 // 2πr donde r=45

const VIAJES_INICIALES = [
  {
    id: 1, nombre: 'Grecia', flag: '🏛️',
    gradiente: ['#6A9AB8', '#2C5A78'],
    fecha: 'ago 12 – ago 26, 2025',
    objetivo: 8000, ahorrado: 4200,
    categorias: [
      { emoji: '✈️', nombre: 'Vuelos',       gastado: 1800, presupuesto: 1800, color: '#98B4C8' },
      { emoji: '🏨', nombre: 'Hospedaje',     gastado: 1200, presupuesto: 2200, color: '#C8A04A' },
      { emoji: '🍷', nombre: 'Comida & vino', gastado: 400,  presupuesto: 1500, color: '#F0C4A8' },
      { emoji: '🏛️', nombre: 'Actividades',   gastado: 0,    presupuesto: 800,  color: '#8EAA7A' },
      { emoji: '🛍️', nombre: 'Compras',       gastado: 800,  presupuesto: 500,  color: '#C89898' },
    ],
  },
  {
    id: 2, nombre: 'Tokio', flag: '🌸',
    gradiente: ['#C89898', '#9A7090'],
    fecha: 'por definir',
    objetivo: 12000, ahorrado: 1500,
    categorias: [],
  },
]

export default function Viajes() {
  const { theme } = useTheme()
  const s = makeStyles(theme)

  const [viajes, setViajes]   = useState(VIAJES_INICIALES)
  const [selIdx, setSelIdx]   = useState(0)
  const [modalOpen, setModal] = useState(false)
  const [form, setForm]       = useState({ nombre: '', objetivo: '', fecha: '' })

  const viaje  = viajes[selIdx]
  const pct    = Math.min(Math.round((viaje.ahorrado / viaje.objetivo) * 100), 100)
  const falta  = Math.max(viaje.objetivo - viaje.ahorrado, 0)
  const ringOff = C - (pct / 100) * C

  function agregarViaje() {
    if (!form.nombre || !form.objetivo) return
    const nuevo = {
      id: Date.now(), nombre: form.nombre, flag: '✈️',
      gradiente: [theme.terra, theme.terraDeep],
      fecha: form.fecha || 'por definir',
      objetivo: parseFloat(form.objetivo), ahorrado: 0,
      categorias: [],
    }
    const nuevos = [...viajes, nuevo]
    setViajes(nuevos)
    setSelIdx(nuevos.length - 1)
    setModal(false)
    setForm({ nombre: '', objetivo: '', fecha: '' })
  }

  return (
    <div style={s.container}>

      <div style={s.header}>
        <p style={s.eyebrow}>mis</p>
        <h1 style={s.titulo}>viajes <em style={s.tituloEm}>soñados</em></h1>
      </div>

      <div style={s.tabs}>
        {viajes.map((v, i) => (
          <button key={v.id} onClick={() => setSelIdx(i)}
            style={{ ...s.tab, ...(selIdx === i ? s.tabActive : {}) }}>
            <span style={s.tabFlag}>{v.flag}</span>
            {v.nombre}
          </button>
        ))}
        <button onClick={() => setModal(true)} style={s.tabAdd}>＋ nuevo</button>
      </div>

      <div style={{ ...s.heroCard, background: `linear-gradient(160deg, ${viaje.gradiente[0]} 0%, ${viaje.gradiente[1]} 100%)` }}>
        <p style={s.heroLabel}>✈️ próximo viaje</p>
        <h2 style={s.heroTitulo}>{viaje.nombre}</h2>
        <p style={s.heroFecha}>{viaje.fecha}</p>
        <div style={s.heroStats}>
          {[
            { label: 'meta total', val: `$${viaje.objetivo.toLocaleString('es')}` },
            { label: 'ahorrado',   val: `$${viaje.ahorrado.toLocaleString('es')}` },
            { label: 'me faltan',  val: `$${falta.toLocaleString('es')}` },
          ].map(({ label, val }, i, arr) => (
            <div key={i} style={{ ...s.heroStat, borderRight: i < arr.length - 1 ? '1px solid rgba(255,255,255,0.12)' : 'none' }}>
              <div style={s.heroStatLabel}>{label}</div>
              <div style={s.heroStatVal}>{val}</div>
            </div>
          ))}
        </div>
      </div>

      <div style={s.ringSection}>
        <div style={s.ringWrap}>
          <svg width="100" height="100" viewBox="0 0 100 100">
            <defs>
              <linearGradient id="ringG" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" stopColor={theme.sky} />
                <stop offset="100%" stopColor="#3A6A8A" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="45" fill="none" stroke={theme.sky + '33'} strokeWidth="10" />
            <circle cx="50" cy="50" r="45" fill="none" stroke="url(#ringG)" strokeWidth="10"
              strokeLinecap="round" strokeDasharray={C} strokeDashoffset={ringOff}
              transform="rotate(-90 50 50)" style={{ transition: 'stroke-dashoffset 1s ease' }} />
          </svg>
          <div style={s.ringCenter}>
            <div style={s.ringPct}>{pct}%</div>
            <div style={s.ringSub}>logrado</div>
          </div>
        </div>
        <div>
          <p style={s.ringTitulo}>¡vas muy bien! ✨</p>
          <p style={s.ringInfo}>
            ahorra ${falta > 0 ? Math.round(falta / 4).toLocaleString('es') : 0}/mes y lo logras
          </p>
        </div>
      </div>

      {viaje.categorias.length > 0 && (
        <div style={s.seccion}>
          <h2 style={s.secTitulo}>Desglose del viaje</h2>
          {viaje.categorias.map(cat => {
            const pctCat = cat.presupuesto > 0 ? Math.min((cat.gastado / cat.presupuesto) * 100, 100) : 0
            const sobre  = cat.gastado > cat.presupuesto
            return (
              <div key={cat.nombre} style={s.catCard}>
                <div style={s.catTop}>
                  <div style={{ ...s.catEmoji, background: `${cat.color}33` }}>{cat.emoji}</div>
                  <div style={{ flex: 1 }}>
                    <div style={s.catNombre}>{cat.nombre}</div>
                  </div>
                  <div style={{ textAlign: 'right' }}>
                    <div style={{ ...s.catGastado, color: sobre ? theme.terra : theme.ink }}>
                      ${cat.gastado.toLocaleString('es')}
                    </div>
                    <div style={s.catPresupuesto}>de ${cat.presupuesto.toLocaleString('es')}</div>
                  </div>
                </div>
                <div style={s.catBar}>
                  <div style={{ ...s.catBarFill, width: `${pctCat}%`, background: `linear-gradient(90deg, ${cat.color}88, ${cat.color})` }} />
                </div>
                {sobre && (
                  <p style={s.catSobre}>
                    te pasaste ${(cat.gastado - cat.presupuesto).toLocaleString('es')} — ¿lo habías planeado?
                  </p>
                )}
              </div>
            )
          })}
        </div>
      )}

      {viaje.categorias.length === 0 && (
        <p style={s.vacio}>agrega categorías para desglosar el presupuesto de este viaje 🌿</p>
      )}

      {modalOpen && (
        <div style={s.overlay} onClick={e => e.target === e.currentTarget && setModal(false)}>
          <div style={s.modal}>
            <div style={s.handle} />
            <h2 style={s.modalTitulo}>nuevo sueño de viaje ✈️</h2>
            <p style={s.modalSub}>¿a dónde quieres ir?</p>
            <label style={s.inputLabel}>destino</label>
            <input style={s.input} placeholder="ej: Tokio, París, Patagonia..."
              value={form.nombre} onChange={e => setForm(p => ({ ...p, nombre: e.target.value }))} />
            <label style={s.inputLabel}>presupuesto total ($)</label>
            <input style={{ ...s.input, textAlign: 'center', fontFamily: fonts.display, fontSize: 24 }}
              type="number" placeholder="5000"
              value={form.objetivo} onChange={e => setForm(p => ({ ...p, objetivo: e.target.value }))} />
            <label style={s.inputLabel}>¿cuándo? (opcional)</label>
            <input style={s.input} placeholder="ej: junio 2026"
              value={form.fecha} onChange={e => setForm(p => ({ ...p, fecha: e.target.value }))} />
            <button style={s.modalBtn} onClick={agregarViaje}>empezar a soñar ✦</button>
          </div>
        </div>
      )}

    </div>
  )
}

const makeStyles = (t) => ({
  container:      { maxWidth: 420, margin: '0 auto', padding: '32px 20px 110px', fontFamily: fonts.body, background: t.cream, minHeight: '100vh' },
  header:         { marginBottom: 20 },
  eyebrow:        { fontFamily: fonts.script, fontSize: 16, color: t.inkLight, marginBottom: 2 },
  titulo:         { fontFamily: fonts.display, fontSize: 38, fontWeight: 300, color: t.ink, letterSpacing: -1 },
  tituloEm:       { fontStyle: 'italic', color: t.sky },
  tabs:           { display: 'flex', gap: 8, marginBottom: 20, overflowX: 'auto', scrollbarWidth: 'none', paddingBottom: 4 },
  tab:            { flex: '0 0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 3, padding: '10px 14px', borderRadius: 16, border: `1.5px solid ${t.blush}55`, background: t.paper, cursor: 'pointer', fontSize: 13, color: t.inkMid, fontFamily: fonts.body },
  tabActive:      { background: t.sky + '22', borderColor: t.sky, color: '#4A7A9A' },
  tabFlag:        { fontSize: 20, display: 'block' },
  tabAdd:         { flex: '0 0 auto', padding: '10px 16px', borderRadius: 16, border: `2px dashed ${t.sky}55`, background: 'transparent', cursor: 'pointer', color: t.sky, fontFamily: fonts.script, fontSize: 15 },
  heroCard:       { borderRadius: 24, padding: '24px 22px', marginBottom: 16, boxShadow: '0 16px 40px rgba(74,122,154,0.35)' },
  heroLabel:      { fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'rgba(255,255,255,0.6)', marginBottom: 6 },
  heroTitulo:     { fontFamily: fonts.display, fontSize: 34, fontWeight: 300, color: 'white', marginBottom: 4 },
  heroFecha:      { fontFamily: fonts.script, fontSize: 17, color: 'rgba(255,255,255,0.65)', marginBottom: 20 },
  heroStats:      { display: 'flex', background: 'rgba(255,255,255,0.1)', borderRadius: 16, overflow: 'hidden', backdropFilter: 'blur(10px)' },
  heroStat:       { flex: 1, padding: '14px 12px' },
  heroStatLabel:  { fontSize: 10, letterSpacing: 1, textTransform: 'uppercase', color: 'rgba(255,255,255,0.55)', marginBottom: 4 },
  heroStatVal:    { fontFamily: fonts.display, fontSize: 18, fontWeight: 600, color: 'white' },
  ringSection:    { display: 'flex', alignItems: 'center', gap: 20, background: t.paper, border: `1px solid ${t.blush}44`, borderRadius: 22, padding: 20, marginBottom: 24 },
  ringWrap:       { position: 'relative', flexShrink: 0 },
  ringCenter:     { position: 'absolute', inset: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' },
  ringPct:        { fontFamily: fonts.display, fontSize: 22, fontWeight: 600, color: '#3A6A8A', lineHeight: 1 },
  ringSub:        { fontFamily: fonts.script, fontSize: 12, color: t.inkLight, marginTop: 2 },
  ringTitulo:     { fontFamily: fonts.display, fontSize: 18, color: t.ink, marginBottom: 4 },
  ringInfo:       { fontFamily: fonts.script, fontSize: 15, color: t.inkLight },
  seccion:        { marginBottom: 24 },
  secTitulo:      { fontFamily: fonts.display, fontSize: 20, fontWeight: 400, color: t.ink, marginBottom: 14 },
  catCard:        { background: t.paper, border: `1px solid ${t.blush}44`, borderRadius: 18, padding: '14px 16px', marginBottom: 10 },
  catTop:         { display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 },
  catEmoji:       { width: 42, height: 42, borderRadius: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20, flexShrink: 0 },
  catNombre:      { fontSize: 14, fontWeight: 500, color: t.ink },
  catGastado:     { fontFamily: fonts.display, fontSize: 17, fontWeight: 600 },
  catPresupuesto: { fontSize: 12, color: t.inkLight },
  catBar:         { height: 6, background: t.blush + '33', borderRadius: 6, overflow: 'hidden' },
  catBarFill:     { height: '100%', borderRadius: 6 },
  catSobre:       { fontFamily: fonts.script, fontSize: 13, color: t.terra, marginTop: 6 },
  vacio:          { fontFamily: fonts.script, fontSize: 16, color: t.inkLight, textAlign: 'center', padding: '20px 0' },
  overlay:        { position: 'fixed', inset: 0, background: 'rgba(42,32,24,0.4)', backdropFilter: 'blur(4px)', zIndex: 300, display: 'flex', alignItems: 'flex-end', justifyContent: 'center' },
  modal:          { background: t.paper, borderRadius: '28px 28px 0 0', padding: '24px 24px 44px', width: '100%', maxWidth: 420 },
  handle:         { width: 36, height: 4, background: t.blush, borderRadius: 4, margin: '0 auto 24px' },
  modalTitulo:    { fontFamily: fonts.display, fontSize: 24, fontWeight: 300, color: t.ink, marginBottom: 6 },
  modalSub:       { fontFamily: fonts.script, fontSize: 16, color: t.inkLight, marginBottom: 20 },
  inputLabel:     { fontSize: 11, fontWeight: 500, color: t.inkMid, textTransform: 'uppercase', letterSpacing: 1, display: 'block', marginBottom: 8, marginTop: 14 },
  input:          { width: '100%', background: t.inputBg, border: `1.5px solid ${t.blush}`, borderRadius: 14, padding: '14px 16px', fontFamily: fonts.body, fontSize: 15, color: t.ink, outline: 'none', boxSizing: 'border-box' },
  modalBtn:       { width: '100%', marginTop: 24, padding: 18, border: 'none', borderRadius: 18, background: t.sky + ' linear-gradient(135deg, ' + t.sky + ', #3A6A8A)', color: 'white', fontFamily: fonts.display, fontSize: 20, fontStyle: 'italic', cursor: 'pointer', boxShadow: '0 8px 24px rgba(74,122,154,0.3)' },
})
